import { IBlobSasModel, IIntakePetModel, IntakePetModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';

export class ImageService {
  // #region Private Variables
  private static baseUrl: string = '/api/';
  private static publicUserHeader: any = {
    vpca: '351BD313-2C19-442B-BC87-C69356EB59EF',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  };
  // #endregion

  static tags = {
    uploadIntakePetPhotoPublic: 'uploadIntakePetPhotoPublic',
  };

  static uploadIntakePetPhotoPublic = (
    sasModel: IBlobSasModel,
    options?: ServiceMethodOptions,
  ): Promise<IntakePetModel> => {
    return trackPromise(
      new Promise<IntakePetModel>((resolve, reject) => {
        http(`${this.baseUrl}/intake/petphoto/`)
          .mergeOptions({ headers: this.publicUserHeader })
          .post<IIntakePetModel>(sasModel)
          .then((request) => {
            ServiceHelper.showSuccess('Upload Successful', options);
            resolve(new IntakePetModel(request));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to upload photo.', options);
            reject(err);
          });
      }),
      this.tags.uploadIntakePetPhotoPublic,
    );
  };
}
